// extracted by mini-css-extract-plugin
export default {"sideEffectsSelect":"SideEffectsSelect_sideEffectsSelect__dwE5d","sideEffectsSelectOption":"SideEffectsSelect_sideEffectsSelectOption__Ro54b"};